import { useTranslation } from 'react-i18next'

export const useGetLanguageDescription = () => {
  const { t } = useTranslation()

  return (locale: string, format: 'long' | 'short' = 'long') => t(`languages.${format}.${locale}`)
}
